export default "__VITE_ASSET__6e554e73__"